var customObj = {
  modifyAltValue: function (imagePath, imageValue) {
    jQuery(imagePath).attr("alt", "").attr("alt", imageValue);
  },
  addSkipToContentId: function () {
    jQuery(".page-body-content").attr("id", "acsbContent");
  },
};

function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

const debouncedOnDomChange = debounce(function () {

  $(".plyr__progress input").removeAttr("aria-valuemax");
  $(".plyr__progress input").removeAttr("aria-valuemin");
  $(".plyr__progress input").removeAttr("aria-valuenow");

}, 500);
const observer = new MutationObserver((mutations) => {
  debouncedOnDomChange();
});
// Configuration of the observer
const config = {
  childList: true, // Observe direct children
  subtree: true, // and lower descendants
};
// Start observing the document body (or any specific element)
observer.observe(document.body, config);

document.addEventListener("DOMContentLoaded", function () {

  $("#gsAppContainer fieldset").attr("role", "none");
  var $aElement = $("button.myregistry a");
  $aElement.detach();
  $("button.myregistry").after($aElement);

  $('.shopify-product-form a[role="tooltip"] span').removeAttr("aria-hidden");
  $('.shopify-product-form a[role="tooltip"]').removeAttr("role");
  $('.shopify-product-form a[role="tooltip"] span').removeAttr("hidden");
  $('.shopify-product-form a[role="tooltip"] span').addClass("sr-only");

  $(".product-gallery .plyr--video input").removeAttr("min");
  $(".product-gallery .plyr--video input").removeAttr("max");
});

jQuery("document").ready(function () {
  customObj.modifyAltValue(
    ".ecom-2rc0rmhm65m figure picture img",
    "OUR PHILOSOPHY"
  );
  customObj.modifyAltValue(
    ".ecom-715wvai1nlo figure picture img",
    "OUR MISSION"
  );
  customObj.addSkipToContentId();

  // A11y Changes
  $(".product__description *:not(ul) > li").wrapAll("<ul/>");
  $(".product__description iframe").attr("title", "Product video");

  setTimeout(function () {}, 3000);
});
